<template>
  <div class="personalInfo">
    <el-container>
      <el-header class="topNav">
        <h1 class="site-navbar__brand"
            @click="$.push({ name: 'Home' })">
          <a class="site-navbar__brand-lg"
             href="javascript:;">
            <img src="../assets/img/login.png">
          </a>
        </h1>
        <p class="desc">个人信息</p>
        <p class="back"
           @click="goback()"><a><i class="el-icon-back"></i>返回首页</a></p>
        <div class="personal">
          <el-dropdown :show-timeout="0"
                       size='small'
                       placement="bottom">
            <p class="el-dropdown-link">
              <img v-if="userImg  && userImg != 'null'"
                   :src="form.img "
                   style="height:36px;width:36px;border-radius:50% 50%;">
              <img v-else
                   style="height:36px"
                   src="../assets/img/default-header.png"
                   :alt="userName">
              <span>{{ userName }}</span>
            </p>
            <el-dropdown-menu slot="dropdown"
                              style="width: 110px;">
              <el-dropdown-item>个人信息</el-dropdown-item>
              <el-dropdown-item @click.native="logoutHandle()">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main class="content">
        <div class="center">
          <el-tabs v-model="activeName"
                   class="tabs">
            <el-tab-pane label="基本信息"
                         name="first">
              <div class="photo">
                <img class="portrait" v-if="form.img  && form.img != 'null'"
                     :src="form.img " />
                     <img v-else
                     style="height:150px"
                   src="../assets/img/default-header.png"
                   :alt="userName">
                <div class="editPho"
                     @click="updatePho()">编辑头像</div>
<!--                <div @click="editPersonalInfo()">修改资料</div>-->
                <div @click="editPassword()">修改密码</div>
                <div @click="logoutHandle()">退出登录</div>
              </div>
              <div class="infomation">
                <el-form ref="form"
                         class="infos"
                         :model="form"
                         label-width="100px">
                  <el-form-item label="账号：">
                    <el-input v-model="form.account"
                              disabled></el-input>
                  </el-form-item>
                  <el-form-item label="姓名：">
                    <el-input v-model="form.name"
                              disabled></el-input>
                  </el-form-item>
<!--                  <el-form-item label="性别：">-->
<!--                    <el-input v-model="form.sex"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="民族：" v-if="form.type ==1">-->
<!--                    <el-input v-model="form.nation" disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="身份：">-->
<!--                    <el-input :value="form.type | userType"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="教工号：" v-if="form.type ==1">-->
<!--                    <el-input v-model="form.account"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="学号：" v-if="form.type ==2">-->
<!--                    <el-input v-model="form.account" disabled></el-input>-->
<!--                  </el-form-item>-->

<!--                  <el-form-item label="院校：">-->
<!--                    <el-input v-model="form.facultyName" disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="专业：" v-if="form.type ==2">-->
<!--                    <el-input v-model="form.professionName" disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="班级："-->
<!--                                v-if="form.type ==2">-->
<!--                    <el-input v-model="form.className"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="职称："-->
<!--                                v-if="form.type ==1">-->
<!--                    <el-input v-model="form.professional"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="学历："-->
<!--                                v-if="form.type ==1">-->
<!--                    <el-input v-model="form.education"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="昵称：">-->
<!--                    <el-input v-model="form.nickname"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="个性签名：">-->
<!--                    <el-input v-model="form.signature"-->
<!--                              disabled></el-input>-->
<!--                  </el-form-item>-->
                </el-form>
              </div>
            </el-tab-pane>
<!--            <el-tab-pane label="账户信息"-->
<!--                         name="second">-->
<!--              <el-form ref="accountForm"-->
<!--                       class="accountInfo"-->
<!--                       :model="accountForm"-->
<!--                       label-width="100px">-->
<!--                <el-form-item label="账号：">-->
<!--                  <el-input v-model="form.account"-->
<!--                            disabled></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="手机：">-->
<!--                  <el-input v-model="form.phone"-->
<!--                            disabled></el-input>-->
<!--                </el-form-item>-->
<!--&lt;!&ndash;                <el-form-item label="微信：">-->
<!--                  <el-input v-model="form.pcOpenid"-->
<!--                            disabled></el-input>-->
<!--                </el-form-item>&ndash;&gt;-->
<!--                <p class="updatePhone"-->
<!--                   @click="newPhone()">更换手机</p>-->
<!--&lt;!&ndash;                <p class="Unbundling"-->
<!--                   v-if="unbindingVisible"-->
<!--                   @click="unBindingPcWechat">解绑</p>-->
<!--                <p class="Unbundling"-->
<!--                   v-if="bindingVisible"-->
<!--                   @click="bindingShow">绑定</p>&ndash;&gt;-->
<!--              </el-form>-->

<!--            </el-tab-pane>-->
          </el-tabs>
        </div>
      </el-main>
      <el-footer class="footer">
        <span>版权所有 · 河南恩久信息科技有限公司</span>
        <span>服务热线：0371-55367299</span>
        <span>豫ICP备16019446号</span>
      </el-footer>
    </el-container>
    <!-- 弹窗，上传头像 -->
    <el-dialog class="uploadPhoto"
               title="上传头像"
               width="30%"
               :visible.sync="photoVisible"
               @close="isClose"
               :append-to-body="true">
      <el-upload :disabled="photoDisabled"
                 ref="upload"
                 class="avatar-uploader"
                 :action="url"
                 :show-file-list="false"
                 :limit="1"
                 :on-change="successOutline"
                 accept=".png,.jpg,.jpeg"
                 :on-success="handleAvatarSuccess"
                 :before-upload="beforeAvatarUpload"
                 :auto-upload="false">
        <img v-if="imageUrl"
             :src="imageUrl"
             class="avatar">
        <i v-else
           class="el-icon-plus avatar-uploader-icon"></i>
        <div class="isShowImg"
             v-if="photoDisabled">
          <span>
            <i class="el-icon-zoom-in"
               @click="isShowImg"></i>
          </span>
          <span>
            <i class="el-icon-delete"
               @click="isDeleteImg"></i>
          </span>

        </div>
      </el-upload>

      <el-dialog :visible.sync="photoImg"
                 append-to-body>
        <img width="100%"
             :src="imageUrl"
             alt="">
      </el-dialog>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="photoVisible = false">取消</el-button>
        <el-button type="primary"
                   @click="uploaderPho()">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑个人信息"
               :visible.sync="infoVisiable"
               :close-on-click-modal="false"
               width="650px">
      <el-form ref="editForm"
               class="infos"
               :model="editForm"
               label-width="100px">
        <el-form-item label="性别：" style="text-align: left">
          <el-radio v-model="editForm.sex" label="男">男</el-radio>
          <el-radio v-model="editForm.sex" label="女">女</el-radio>
          <el-radio v-model="editForm.sex" label="保密">保密</el-radio>
        </el-form-item>
        <el-form-item label="民族：" v-if="form.type == 1" style="text-align: left">
          <el-select v-model="editForm.nation">
            <template v-for="(nation,index) in nationArrays">
            <el-option :value="nation">{{nation}}</el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="职称：" v-if="form.type == 1" style="text-align: left">
          <el-select v-model="editForm.professional">
              <el-option value="副高职">副高职</el-option>
              <el-option value="正高职">正高职</el-option>
              <el-option value="副院长">副院长</el-option>
              <el-option value="院长">院长</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历：" v-if="form.type == 1" style="text-align: left">
          <el-select v-model="editForm.education">
            <el-option value="本科">本科</el-option>
            <el-option value="研究生">研究生</el-option>
            <el-option value="博士">博士</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input v-model="editForm.nickname"
                    maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="个性签名：">
          <el-input v-model="editForm.signature" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="infoVisiable = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitEditForm()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改密码"
               :visible.sync="passwordVisiable"
               :close-on-click-modal="false"
               width="500px">

      <el-form :model="ruleForm"
               size="medium"
               status-icon
               :rules="rules"
               ref="ruleForm"
               label-width="120px"
               class="demo-ruleForm newPasswrod">
        <el-form-item label="输入原密码："
                      prop="password">
          <el-input type="password"
                    v-model="ruleForm.password"
                    placeholder="输入原密码"
                    show-password
                    autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="输入新密码："
                      prop="newPassword">
          <el-input type="password"
                    v-model="ruleForm.newPassword"
                    placeholder="密码需要6位以上字母和数字的组合"
                    show-password
                    autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码："
                      prop="checkPass">
          <el-input type="password"
                    placeholder="请输入"
                    v-model="ruleForm.checkPass"
                    show-password
                    autocomplete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="passwordVisiable = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="更换手机号"
               class="phoneDialog"
               :visible.sync="phoneVisiable"
               :close-on-click-modal="false"
               width="550px">
      <el-form label-width="120px"
               ref="phoneForm"
               :model="editPhoneForm"
               :rules="editPhoneRules"
               class="phoneForm">
        <el-form-item label="密码："
                      type="password"
                      prop="password">
          <el-input v-model="editPhoneForm.password"
                    placeholder="请输入密码"
                    show-password />
        </el-form-item>
        <el-form-item label="手机号"
                      prop="phone">
          <el-input type="text"
                    placeholder="请输入手机号"
                    v-model="editPhoneForm.phone" />
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="phoneVisiable = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitEditPhone()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="wxConfig.wxVisible"
               :close-on-click-modal="false"
               width="500px">
      <div class="weichat" style="padding-bottom: 30px">
        <span style="color: #3C94ED">扫一扫绑定微信</span>
        <wxlogin :theme="'black'"
                 :appid="wxConfig.appid"
                 href="data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30NCi5qc193eF9kZWZhdWx0X3RpcHtkaXNwbGF5OiBub25lO30="
                 :scope="'snsapi_login'"
                 :redirect_uri="wxConfig.redirect_uri">
        </wxlogin>
        <span style="margin-top: -75px;display: block;">请使用微信扫描二维码确认绑定账号</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryUserInfo, updateUser, loginOut, updatePassword, updatePhone, unBindingPcWechat, bindingPcWechat } from '@/api/api'
import { clearLoginInfo, setUserInfo } from '@/utils'
import { isMobile } from '@/utils/validate'
import wxlogin from 'vue-wxlogin'
import { getUploadUrl } from '@/api/file_api'
import {nationArrays} from "../data";

export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!/^.*(?=.{6,})(?=.*\d)(?=.*[a-z]).*$/.test(value)) {
        callback(new Error('密码需要6位以上位字母和数字'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!isMobile(this.editPhoneForm.phone)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }

    return {
      userImg: this.$cookie.get("headImg"),
      userName: this.$cookie.get("name"),
      activeName: 'first',
      wxShow: true,
      unbindingVisible: false,
      bindingVisible: false,
      nationArrays,
      form: {
        account: '',
        name: '',
        sex: '',
        nation: '',
        type: '',
        phone: '',
        pcOpenid: '',
        facultyNum: '',
        facultyName: '',
        professional: '',
        professionName: '',
        className: '',
        education: '',
        nickname: '',
        signature: '',
        img: ''
      },
      editForm: {
        sex: '',
        nation: '',
        professional: '',
        education: '',
        nickname: '',
        signature: ''
      },
      accountForm: {
        account: '12016456489',
        phone: '18838364206',
        email: 'liyouxian.@sina.com',
        wechat: 'youxian1688,'
      },
      editPhoneForm: {
        userId: this.$cookie.get('userId'),
        password: '',
        phone: ''
      },
      passwordVisiable: false,
      ruleForm: {
        userId: this.$cookie.get('userId'),
        password: '',
        newPassword: '',
        checkPass: ''
      },
      rules: {
        password: [
          { required: true, message: '原密码不能为空', trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur', required: true }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur', required: true }
        ]
      },
      editPhoneRules: {
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur', required: true }
        ]
      },
      infoVisiable: false,
      photoVisible: false,
      phoneVisiable: false,
      nextStep: false,
      password: '',
      phoneNumber: '',
      imageUrl: "",
      photoDisabled: false,
      photoImg: false,
      url: '',
      code: '',
      wxConfig: {
        appid: process.env.WX_APPID,
        redirect_uri: 'http://jbzk.ejkj.top/personal?returnType=binding',
        wxVisible: false,
      }
    }
  },
  mounted () {
    this.queryUserInfo()
    this.url = getUploadUrl()
    if (typeof this.$route.query.returnType != 'undefined') {
      let returnType = this.$route.query.returnType
      this.code = this.$route.query.code
      if (returnType == 'binding') {
        //微信绑定
        this.bindingPcWechat()
      }
    }
  },
  components: {
    wxlogin
  },
  methods: {
    queryUserInfo () {
      queryUserInfo().then(res => {
        if (res && res.code === 0) {
          this.form = res.data
          if (this.form.pcOpenid) {
            this.unbindingVisible = true
            this.bindingVisible = false
          } else {
            this.unbindingVisible = false
            this.bindingVisible = true
          }
          this.editForm = res.data
          this.userName = res.data.name
          setUserInfo(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getUploadUrl () {
      return getUploadUrl()
    },
    bindingPcWechat () {
      bindingPcWechat({
        code: this.code,
        userId: this.$cookie.get('userId')
      }).then(res => {
        if (res && res.code === 0) {
          this.$message.success('微信绑定成功')
          this.$cookie.set('pcOpenid', res.data)
          this.wxConfig.wxVisible = false
          this.queryUserInfo()
          this.$router.push({ path: '/personal' })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    updateUser () {
      updateUser(this.editForm).then(res => {
        if (res && res.code === 0) {
          this.$message.success('修改成功')
          this.infoVisiable = false
          this.queryUserInfo()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    updatePassword () {
      updatePassword(this.ruleForm).then(res => {
        if (res && res.code === 0) {
          this.$message.success('密码修改成功,请重新登录')
          clearLoginInfo()
          this.$router.push({ path: "/" })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    logoutHandle () {
      loginOut({
        token: this.$cookie.get("token")
      }).then(res => {
        if (res && res.code === 0) {
          this.$message.success('退出登录成功')
          clearLoginInfo()
          this.$router.push({ path: "/" })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitEditPhone () {
      this.$refs['phoneForm'].validate((valid) => {
        if (valid) {
          this.updatePhone()
        }
      })
    },
    updatePhone () {
      updatePhone(this.editPhoneForm).then(res => {
        if (res && res.code === 0) {
          this.$message.success('手机号修改成功')
          this.phoneVisiable = false
          this.queryUserInfo()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    unBindingPcWechat () {
      this.$confirm(`确定要解绑微信?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        unBindingPcWechat().then(res => {
          if (res && res.code === 0) {
            this.$message.success('微信解绑成功')
            this.queryUserInfo()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    bindingShow () {
      this.wxConfig.wxVisible = true
    },
    goback () {
      history.go(-1)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updatePassword()
        }
      })
    },
    editPassword () {
      this.passwordVisiable = true;
    },
    editPersonalInfo () {
      this.infoVisiable = true
    },
    submitEditForm () {
      this.updateUser()
    },
    updatePho () {
      this.photoVisible = true
    },
    uploaderPho () {
      this.$refs['upload'].submit()
    },
    isSure () {

    },
    newPhone () {
      this.editPhoneForm.phone = ''
      this.editPhoneForm.password = ''
      this.phoneVisiable = true;
    },
    goNext () {
      this.nextStep = true
    },
    isClose () {

    },
    successOutline (file, fileList) {
      if (this.isSucess) {
        this.$refs['upload'].clearFiles()
        this.photoDisabled = false
        this.imageUrl = ''
        this.isSucess = false
      } else {
        this.imageUrl = URL.createObjectURL(file.raw)
        this.photoDisabled = true
      }
    },
    handleAvatarSuccess (res) {
      this.isSucess = true
      if (res.code === 0) {
        updateUser({
          userId: this.$cookie.get('userId'),
          img: res.data.location
        }).then(res => {
          if (res && res.code === 0) {
            this.$message.success('头像上传成功')
            this.photoVisible = false
            this.queryUserInfo()
          } else {
            this.$message.error(res.msg)

          }
        })
      } else {
        this.$message({
          type: 'info',
          message: res.msg
        })
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' ||
        file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是JPG或者PNG格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    isShowImg () {
      this.photoImg = true
    },
    isDeleteImg () {
      this.$refs['upload'].clearFiles()
      this.photoDisabled = false
      this.imageUrl = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.personalInfo {
  height: 940px;
  .topNav {
    position: relative;
    height: 70px;
    padding-top: 16px;
    box-sizing: border-box;
    display: flex;
    .site-navbar__brand {
      margin-left: 47px;
    }
    .desc {
      margin-left: 49px;
      font-weight: 400;
      font-size: 28px;
    }
    .back {
      position: absolute;
      right: 185px;
      top: 20px;
      color: #3c94ed;
      cursor: pointer;
    }
    .personal {
      position: absolute;
      right: 45px;
      top: 7px;
      color: #fff;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
      .el-dropdown-link {
        width: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .content {
    width: 100%;
    background: #f3f6f9;
    .center {
      margin: 0 auto;
      margin-top: 20px;
      width: 1280px;
      height: 790px;
      background: #fff;
      box-shadow: 0px 3px 6px rgba(60, 148, 237, 0.2);
      opacity: 1;
      border-radius: 5px;
      .tabs /deep/.el-tabs__nav-scroll {
        padding-left: 46px;
      }
    }
    .photo {
      width: 150px;
      height: 100%;
      margin-left: 135px;
      float: left;
      .portrait {
        width: 150px;
        height: 150px;
        margin-top: 86px;
        margin-bottom: 22px;
        background: wheat;
      }
      div {
        margin: 0 auto;
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 60px;
        border: 1px solid #aedbff;
        color: #3d84ff;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .editPho {
        margin-bottom: 100px;
      }
    }
    .infomation {
      width: 400px;
      height: 100%;
      float: right;
      margin-right: 265px;
      .infos {
        margin-top: 32px;
      }
    }
    .accountInfo {
      margin-top: 40px;
      width: 500px;
      position: relative;
      p {
        width: 136px;
        height: 36px;
        line-height: 36px;
        border-radius: 30px;
        border: 1px solid #aedbff;
        text-align: center;
        color: #3d84ff;
        cursor: pointer;
      }
      .updatePhone {
        position: absolute;
        top: 63px;
        right: -166px;
      }
      .Unbundling {
        position: absolute;
        top: 125px;
        right: -166px;
      }
      .Unbundling1 {
        position: absolute;
        top: 186px;
        right: -166px;
      }
    }
  }
  .footer {
    height: 35px !important;
    background-color: #151617;
    text-align: center;
    color: #ffffff;
    width: 100%;
    line-height: 35px;
    span {
      margin-right: 15px;
    }
  }
  .phoneForm {
    position: relative;
    .code {
      position: relative;
      top: -52px;
      right: -250px;
      color: #3c94ed;
      cursor: pointer;
    }
  }
}
</style>
<style>
.el-dialog__body {
  padding: 20px 30px 0 !important;
}
.phoneDialog .phoneForm {
  width: 400px;
}
.uploadPhoto .el-dialog__body {
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.uploadPhoto .isShowImg {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.uploadPhoto .isShowImg:hover {
  opacity: 1;
}
.uploadPhoto .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/personal.vue